<template>
  <div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalentradas"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div
          class="modal-content text-center"
          style="width: 100%; max-width: 100%"
        >
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="col-12">
                <div class="row">
                  <div class="col-3">
                    <input
                      class="form-control"
                      placeholder="# Documento"
                      type="text"
                      v-model="current_filter.documento"
                    />
                  </div>
                  <div class="col-3">
                    <TiendaSelectComponent
                      titulo="hide"
                      :current="current_filter"
                    />
                  </div>
                  <div class="col-3">
                    <input
                      v-model="current_filter.fecha_documento"
                      class="form-control"
                      type="date"
                    />
                  </div>
                  <div class="col-1">
                    <button
                      @click="refreshData()"
                      class="btn btn-lg btn-success"
                    >
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                  &nbsp; &nbsp;
                  <div class="col-1">
                    <button
                      @click="defaultData()"
                      class="btn btn-lg btn-success"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div>
                  <!-------------------- Tabla de Resultados -------------------->
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Tienda</th>
                        <th>Proveedor</th>
                        <th>Usuario</th>
                        <th>Fecha</th>
                        <th>Fecha Ultima Edición</th>
                        <th class="text-center">Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="current in dataTabla.results"
                        v-bind:key="current.id"
                        @click="rowClick(current)"
                      >
                        <td>{{ current.documento }}</td>
                        <td>
                          {{ current.recepcion.tienda_obj.codigo }} -
                          {{ current.recepcion.tienda_obj.nombre }}
                        </td>
                        <td>
                          {{ current.proveedor_obj.codigo }} |
                          {{ current.proveedor_obj.nombre }}
                        </td>
                        <td>
                          {{ current.usuario_obj.name }}
                        </td>
                        <td>{{ current.fecha_documento }}</td>
                        <td>
                          <timeago
                            :title="current.fecha_creacion"
                            :datetime="current.fecha_creacion"
                          ></timeago>
                        </td>
                        <td class="text-center">
                          <div
                            data-title="Activo"
                            data-toggle="tooltip"
                            v-html="current.estado_str"
                          ></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-------------------- END - Basic Table -------------------->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  props: ["cargo"],
  components: {
    UsuarioEnTablaComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      current: {},
      current_filter: {},
      dataTabla: [],
      mostrarRefresh: false,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    defaultData() {
      let self = this;
      self.current_filter = {};
      self.dataTabla = "";
    },
    refreshData() {
      let self = this;
      if (self.current_filter.fecha) {
        self.current_filter.fecha_documento = self.current_filter.fecha;
      }
      DynamicService.getActionList(
        "inv",
        "ent_compra",
        "entrada_pendientes_generar_cxp",
        self.current_filter
      ).then((response) => {
        self.dataTabla = response.data;
        console.log(self.dataTabla);
      });
    },
    rowClick(current) {
      let self = this;
      Notifications.alert.confirm(
        "Agregar factura a cargo",
        "¿Esta seguro(a)?",
        "",
        function () {
          console.log(self.cargo.id)
          DynamicService.getActionList(
            "wms",
            "recepcion",
            "generar_cargo_cxp",
            {
              id: current.entrada_por_compra_e,
              cargo: self.cargo.id,
            }
          )
            .then((res) => {
              Notifications.alert.success(
                "Generar cargo por entrada de compra",
                "Generado correctamente"
              );
              $("#modalentradas").modal("hide");
              self.$emit("refreshCargo");
            })
            .catch((err) => {
              Notifications.alert.error(
                "Generar cargo por entrada de compra",
                err.response.data.detail
              );
            });
        }
      );
    },
  },
};
</script>
